import { handleCureStatus, handlePrice, momentFormat, getStatusLabel } from '@/utils'
// 处方详情 基本信息
const BASE_LABEL = [
  {
    label: '姓名：',
    prop: 'patientName',
    class: 'small'
  },
  {
    label: '性别：',
    prop: 'patientGender',
    class: 'small'
  },
  {
    label: '年龄：',
    prop: 'patientAge',
    class: 'small'
  },
  // 插入数据
  {
    label: '医生：',
    prop: 'doctorName',
    class: 'small'
  },
  {
    label: '科室：',
    prop: 'departmentName',
    class: 'small'
  },
  {
    label: '互联网医院：',
    prop: 'agencyId',
    class: 'small'
  },
  {
    label: '关联随访计划：',
    prop: 'followupPlanIds',
    class: 'small'
  }
]
const EN_Add_Label = [
  {
    label: '主诉：',
    prop: 'mainComplaint',
    class: 'small'
  },
  {
    label: '临床诊断：',
    prop: 'westernDiagnosisInfoList',
    class: 'small'
  },
  {
    label: '嘱托：',
    prop: 'taboo',
    class: 'small'
  }
]
const CN_Add_Label = [
  {
    label: '症状简诉：',
    prop: 'mainComplaint',
    class: 'small'
  },
  {
    label: '中医证型：',
    prop: 'chieseDiagnosisInfoList',
    class: 'small'
  }
]
// 协定方
const AN_Add_Label = [
  {
    label: '症状简诉：',
    prop: 'mainComplaint',
    class: 'small'
  },
  {
    label: '诊断：',
    prop: 'westernDiagnosisInfoList',
    class: 'small'
  },
  {
    label: '中医证型：',
    prop: 'chieseDiagnosisInfoList',
    class: 'small'
  }
]
const NEW_Label = [
  {
    label: '治疗状态：',
    prop: 'effectivenessResult',
    class: 'small'
  },
  {
    label: '判定人：',
    prop: 'determineName',
    class: 'small'
  },
  {
    label: '判定时间：',
    prop: 'determineTime',
    class: 'small'
  }
]
// 西药药品信息
const columnWesternMedicine = [
  {
    title: 'SKU编码',
    dataIndex: 'skuCode',
    key: 'skuCode'
  },
  {
    title: 'SKU名称',
    dataIndex: 'skuName',
    key: 'skuName'
  },
  {
    dataIndex: 'quantity',
    key: 'quantity',
    title: '数量（盒）'
  },
  {
    dataIndex: 'usages',
    key: 'usages',
    title: '用法用量'
  },
  {
    dataIndex: 'drugCycle',
    key: 'drugCycle',
    title: '用药周期',
    slots: { customRender: 'drugCycle' }
  },
  {
    dataIndex: 'salePrice',
    key: 'salePrice',
    title: '销售价格'
  },
  {
    dataIndex: 'backup',
    key: 'backup',
    title: '备注'
  }
]
// 中药药品信息
const columnChineseMedicine = [
  { title: '编码', dataIndex: 'code', key: 'code' },
  { title: '药材名称', dataIndex: 'name', key: 'name' },
  {
    title: '计量（克）',
    dataIndex: 'decoctionGram',
    key: 'decoctionGram'
  }
  // { title: '售价（元）chinese', dataIndex: 'price', key: 'price' }
]
// 协定方信息
const agreementMedicine = [
  { title: '编码', dataIndex: 'prescriptionSn', key: 'prescriptionSn' },
  { title: '药方名称', dataIndex: 'prescriptionName', key: 'prescriptionName' }
  // { title: '售价（元）agree', dataIndex: 'price', key: 'price' }
]
// 处方
const CHINESE_DRUG_ADD = [
  { label: '剂型', value: 'dosageType' },
  { label: '用法用量', value: 'usage' },
  // { label: '服用禁忌', value: 'taboo' },
  // { label: '医嘱', value: 'advice' },
  { label: '嘱托', value: 'taboo' },
  { label: '药房备注', value: 'pharmacyRemark' }
]
// 协定方
const AGREEMENT_DRUG_ADD = [
  { label: '剂型', value: 'dosageType' },
  { label: '用法用量', value: 'usage' },
  { label: '用药周期', value: 'cycle' },
  { label: '嘱托', value: 'taboo' },
  { label: '药房备注', value: 'pharmacyRemark' }
]
// 获取处方标签
const getStatusImg = info => {
  const { status, expire, invalid } = info
  return getStatusLabel({ status, expire, invalid })
}
// 处方状态 0：未购， 1：已全部购买， 2：待支付，3 已作废 4:已取消
// NOTE:123个状态都展示为已购买；其他均不变
// const statusImg = [
//   {
//     id: 0,
//     alt: '未购买',
//     src: require('@/assets/img/work-place/buy-notv1.png')
//   },
//   {
//     id: 1,
//     alt: '已购买',
//     src: require('@/assets/img/work-place/buy-already.png')
//   },
//   {
//     id: 2,
//     alt: '已下单未支付',
//     src: require('@/assets/img/work-place/buy-notPay.png')
//   },
//   {
//     //NOTE:部分购买也是已购买
//     id: 3,
//     alt: '已购买',
//     src: require('@/assets/img/work-place/buy-already.png')
//   },
//   { id: 4, alt: '已取消', src: require('@/assets/img/work-place/cancel.png') },
//   { id: 5, alt: '已删除', src: require('@/assets/img/work-place/delete.png') },
//   // 失效
//   { id: 6, alt: '已失效', src: require('@/assets/img/work-place/invalid-already.png') },
//   { id: 7, alt: '已作废', src: require('@/assets/img/work-place/voidv1.png') }
// ]
// 订单信息
const columnOrder = [
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: '医药费',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  // {
  //   title: '优惠券',
  //   dataIndex: 'couponPay',
  //   key: 'couponPay',
  //   width: 180,
  //   customRender: ({ text }) => {
  //     return handlePrice(text)
  //   }
  // },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '订单状态',
    dataIndex: 'orderStatus',
    key: 'orderStatus',
    width: 180
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 180
  },
  {
    title: '支付时间',
    dataIndex: 'payTime',
    key: 'payTime',
    width: 180
  },
  {
    title: '物流单号',
    dataIndex: 'deliveryId',
    key: 'deliveryId',
    width: 180
  },
  {
    title: '发货时间',
    dataIndex: 'sendTime',
    key: 'sendTime',
    width: 180
  },
  {
    title: '签收时间',
    dataIndex: 'receiverTime',
    key: 'receiverTime',
    width: 180,
    customRender: ({ text }) => {
      return momentFormat(text, 'YYYY-MM-DD HH:mm:ss')
    }
  },
  {
    title: '退款金额',
    dataIndex: 'salesPay',
    key: 'salesPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款时间',
    dataIndex: 'refundAt',
    key: 'refundAt',
    width: 180
  },
  {
    title: '药房点评',
    dataIndex: 'reviewContent',
    key: 'reviewContent',
    width: 280,
    ellipsis: true,
    slots: {
      customRender: 'reviewContent'
    }
  }
]
// 售后信息（中药）
const columnSaleChinese = [
  {
    title: '售后单号',
    dataIndex: 'salesSn',
    key: 'salesSn',
    width: 180
  },
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: 'sku编码',
    dataIndex: 'skuNumber',
    key: 'skuNumber',
    width: 180
  },
  {
    title: 'sku名称',
    dataIndex: 'skuName',
    key: 'skuName',
    width: 180
  },
  {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 180
  },
  {
    title: '商品单价',
    dataIndex: 'salePrice',
    key: 'salePrice',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '数量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 180
  },
  {
    title: '退货数量',
    dataIndex: 'returnQuantity',
    key: 'returnQuantity',
    width: 180
  },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  // {
  //   title: '退款金额（元）',
  //   dataIndex: 'returnPrice',
  //   key: 'returnPrice',
  //   width: 180
  // },
  // 退款金额改为“应退金额”和“实退金额”，若未退款，则展示“---”
  {
    title: '应退金额',
    dataIndex: 'shouldRefund',
    key: 'shouldRefund',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实退金额',
    dataIndex: 'returnPrice',
    key: 'returnPrice',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实付运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '退款运费',
    dataIndex: 'refundFreight',
    key: 'refundFreight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款原因',
    dataIndex: 'salesReason',
    key: 'salesReason',
    width: 180
  }
]
// 售后信息（协定方）
const columnSaleAgreement = [
  {
    title: '售后单号',
    dataIndex: 'salesSn',
    key: 'salesSn',
    width: 180
  },
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: 'sku编码',
    dataIndex: 'skuNumber',
    key: 'skuNumber',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: 'sku名称',
    dataIndex: 'skuName',
    key: 'skuName',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 180
  },
  {
    title: '商品单价',
    dataIndex: 'salePrice',
    key: 'salePrice',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '数量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '退货数量',
    dataIndex: 'returnQuantity',
    key: 'returnQuantity',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  // {
  //   title: '退款金额（元）',
  //   dataIndex: 'returnPrice',
  //   key: 'returnPrice',
  //   width: 180
  // },
  // 退款金额改为“应退金额”和“实退金额”，若未退款，则展示“---”
  {
    title: '应退金额',
    dataIndex: 'shouldRefund',
    key: 'shouldRefund',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '实退金额',
    dataIndex: 'returnPrice',
    key: 'returnPrice',
    width: 180,
    customRender: () => {
      return '**'
    }
  },
  {
    title: '实付运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '退款运费',
    dataIndex: 'refundFreight',
    key: 'refundFreight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款原因',
    dataIndex: 'salesReason',
    key: 'salesReason',
    width: 180
  }
]
// 售后信息（西药）
const columnSaleWestern = [
  {
    title: '售后单号',
    dataIndex: 'salesSn',
    key: 'salesSn',
    width: 180
  },
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: 'sku编码',
    dataIndex: 'skuNumber',
    key: 'skuNumber',
    width: 180
  },
  {
    title: 'sku名称',
    dataIndex: 'skuName',
    key: 'skuName',
    width: 180
  },
  {
    title: '数量（盒）',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 180
  },
  {
    title: '退货数量（盒）',
    dataIndex: 'returnQuantity',
    key: 'returnQuantity',
    width: 180
  },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  // {
  //   title: '退款金额（元）',
  //   dataIndex: 'returnPrice',
  //   key: 'returnPrice',
  //   width: 180
  // },
  // 退款金额改为“应退金额”和“实退金额”，若未退款，则展示“---”
  {
    title: '应退金额',
    dataIndex: 'shouldRefund',
    key: 'shouldRefund',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实退金额',
    dataIndex: 'returnPrice',
    key: 'returnPrice',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实付运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '退款运费',
    dataIndex: 'refundFreight',
    key: 'refundFreight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款原因',
    dataIndex: 'salesReason',
    key: 'salesReason',
    width: 180
  }
]
// 活动信息
const columnActive = [
  {
    title: '推荐处方ID',
    dataIndex: 'recommendTemplateId',
    key: 'recommendTemplateId',
    width: 180
  },
  {
    title: '临观活动名称',
    dataIndex: 'activityTemplateName',
    key: 'activityTemplateName',
    width: 180
  },
  {
    title: '治疗状态',
    dataIndex: 'cureStatus',
    key: 'cureStatus',
    width: 180,
    customRender: ({ text }) => {
      return handleCureStatus(text)
    }
  },
  {
    title: '判定人',
    dataIndex: 'assertCureName',
    key: 'assertCureName',
    width: 180
  },
  {
    title: '判定时间',
    dataIndex: 'assertCureTime',
    key: 'assertCureTime',
    width: 180
  },
  {
    title: '结算状态',
    dataIndex: 'accountStatus	',
    key: 'accountStatus	',
    width: 180
  },
  {
    title: '确定结算人',
    dataIndex: 'assertAccountName',
    key: 'assertAccountName',
    width: 180
  },
  {
    title: '确定结算时间',
    dataIndex: 'assertAccountTime',
    key: 'assertAccountTime',
    width: 180
  }
]
export {
  BASE_LABEL,
  EN_Add_Label,
  CN_Add_Label,
  AN_Add_Label,
  columnWesternMedicine,
  columnChineseMedicine,
  agreementMedicine,
  CHINESE_DRUG_ADD,
  AGREEMENT_DRUG_ADD,
  getStatusImg,
  columnOrder,
  columnSaleChinese,
  columnSaleAgreement,
  columnActive,
  columnSaleWestern,
  NEW_Label
}
